module.exports = __webpack_public_path__ + "img/agility-032b90d.png";